import React, { useMemo } from "react";
import { Dropdown as AntDropdown, Menu } from "antd";

const OrderTypeDropDown = ({
  label,
  stateValue,
  options,
  onChange,
  isHidden = false,
}) => {
  const menu = useMemo(() => {
    return (
      <Menu>
        {options?.map(item => (
          <Menu.Item onClick={() => onChange(item)}>{item.label}</Menu.Item>
        ))}
      </Menu>
    );
  }, [options]);
  return (
    !isHidden && (
      <AntDropdown.Button
        overlay={menu}
        type="primary"
        className="ant-dropdown-custom"
        trigger={["click"]}
      >
        {stateValue?.label || ""}
      </AntDropdown.Button>
    )
  );
};

export default OrderTypeDropDown;
